module.exports = __webpack_public_path__ + "static/media/3pod-image.418ab08e.png";